import {CanalNotificationWithMessageCountDto, INotificationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class CanauxActifsUtilisateurResolver implements Resolve<Array<CanalNotificationWithMessageCountDto>> {

  constructor(private notificationsWebServiceClient: INotificationsWebServiceClient) {
  }

  resolve() {
    return this.notificationsWebServiceClient.findAllActiveCanalNotifications();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/canaux-actifs-utilisateur.resolver.ts